import {
  TransactionMessage,
  VersionedTransaction,
  PublicKey,
  Connection,
  ComputeBudgetProgram,
} from '@solana/web3.js';
import {
  TOKEN_PROGRAM_ID,
  ASSOCIATED_TOKEN_PROGRAM_ID,
  createTransferCheckedInstruction,
  getAssociatedTokenAddress,
  createAssociatedTokenAccountInstruction,
  getAccount,
  getMint,
} from '@solana/spl-token';
import { floor } from '@/decimal/round';
interface BuildTransactionOptions {
  priorityFee?: number; // 小费
  computeUnits?: number;
}
const connection = new Connection(
  'https://winter-lively-sky.solana-mainnet.quiknode.pro/ffcfc281b26d2f58e9228529aa650f1c235e77db/'
);
export const sol_buildTokenTransferTransaction = async (
  fromAddress: string,
  toAddress: string,
  contract: string,
  amount: number,
  options: BuildTransactionOptions = {}
) => {
  try {
    const payer = new PublicKey(fromAddress);
    const recipient = new PublicKey(toAddress);
    const mint = new PublicKey(contract);
    const Amount = BigInt(floor(Number(amount) * 10 ** 8, 0)); // (8位精度)
    const { priorityFee = 0, computeUnits = 200_000 } = options;

    // 1. 获取发送者和接收者的关联账户地址
    const [senderATA, recipientATA] = await Promise.all([
      getAssociatedTokenAddress(mint, payer, false, TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID),
      getAssociatedTokenAddress(
        mint,
        recipient,
        false,
        TOKEN_PROGRAM_ID,
        ASSOCIATED_TOKEN_PROGRAM_ID
      ),
    ]);

    // 2. 准备指令数组
    const instructions = [];

    // 3. 检查接收者的关联账户是否存在
    try {
      await getAccount(connection, recipientATA);
    } catch (error) {
      // 如果接收者的关联账户不存在，添加创建账户的指令
      instructions.push(
        createAssociatedTokenAccountInstruction(
          payer,
          recipientATA,
          recipient,
          mint,
          TOKEN_PROGRAM_ID,
          ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    // 4. 获取代币精度
    const mintInfo = await getMint(connection, mint);

    // 5. 添加转账指令
    instructions.push(
      createTransferCheckedInstruction(
        senderATA,
        mint,
        recipientATA,
        payer,
        Amount,
        mintInfo.decimals
      )
    );

    // 6. 添加优先级费用和计算单元设置
    if (priorityFee > 0) {
      instructions.unshift(
        ComputeBudgetProgram.setComputeUnitPrice({
          microLamports: priorityFee,
        })
      );
    }

    instructions.unshift(
      ComputeBudgetProgram.setComputeUnitLimit({
        units: computeUnits,
      })
    );

    // 7. 获取最新的 blockhash
    const { blockhash, lastValidBlockHeight } = await connection.getLatestBlockhash();

    // 8. 创建交易消息
    const messageV0 = new TransactionMessage({
      payerKey: payer,
      recentBlockhash: blockhash,
      instructions,
    }).compileToV0Message();

    // 9. 创建 Versioned Transaction
    const transaction = new VersionedTransaction(messageV0);

    return {
      transaction,
      blockhash,
      lastValidBlockHeight,
    };
  } catch (error) {
    console.error('Build transaction failed:', error);
    throw error;
  }
};
